/* EAGLES TRANSILVANIA — theme behaviour (header, promo, mobile nav, scroll reveal).
   Namespaced IDs (eagles*) to avoid collisions with Horizon. Editor-safe. */
(function () {
  // Arm scroll animations only when JS is present (no-JS => content stays visible).
  // LCP: elementele deja in primul viewport NU se anima — altfel textul devine
  // vizibil tarziu si Chrome muta LCP-ul la momentul dezvaluirii (audit 2026-06-13:
  // LCP 7.3s venea dintr-un paragraf fade-up de sub hero, nu din imagini/video).
  try {
    document.querySelectorAll('.fade-up').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('vis');
    });
  } catch (e) {}
  document.documentElement.classList.add('eagles-anim');

  function setPromoHeight() {
    var promo = document.getElementById('eaglesPromo');
    var h = (promo && !promo.classList.contains('promo--gone')) ? promo.offsetHeight : 0;
    document.documentElement.style.setProperty('--promo-h', h + 'px');
  }

  function initHeader() {
    var header = document.getElementById('eaglesHeader');
    var promo = document.getElementById('eaglesPromo');
    if (header && !header.dataset.bound) {
      header.dataset.bound = '1';
      var onScroll = function () {
        var down = window.scrollY > 40;
        header.classList.toggle('scrolled', down);
        if (promo) promo.classList.toggle('promo--up', down);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    // promo dismiss -> collapse the header offset
    if (promo && !promo.dataset.bound) {
      promo.dataset.bound = '1';
      var x = promo.querySelector('.promo-x');
      if (x) x.addEventListener('click', function () {
        promo.classList.add('promo--gone');
        setPromoHeight();
      });
    }
    setPromoHeight();

    var ham = document.getElementById('eaglesHamburger');
    var mnav = document.getElementById('eaglesMobileNav');
    var ovl = document.getElementById('eaglesNavOverlay');
    var mclose = document.getElementById('eaglesMobileNavClose');
    function closeNav() {
      if (ham) { ham.classList.remove('active'); ham.setAttribute('aria-expanded', 'false'); }
      if (mnav) mnav.classList.remove('open');
      if (ovl) ovl.classList.remove('open');
      document.documentElement.classList.remove('eagles-nav-open');
    }
    if (ham && mnav && ovl && !ham.dataset.bound) {
      ham.dataset.bound = '1';
      ham.addEventListener('click', function () {
        var open = mnav.classList.toggle('open');
        ham.classList.toggle('active', open);
        ham.setAttribute('aria-expanded', open ? 'true' : 'false');
        ovl.classList.toggle('open', open);
        document.documentElement.classList.toggle('eagles-nav-open', open);
      });
      ovl.addEventListener('click', closeNav);
      if (mclose) mclose.addEventListener('click', closeNav);
      mnav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeNav); });
      // Esc to close
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mnav.classList.contains('open')) closeNav();
      });
    }
  }

  function reveal(scope) {
    scope = scope || document;
    var els = scope.querySelectorAll('.fade-up:not(.vis)');
    var designMode = window.Shopify && window.Shopify.designMode;
    if (designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vis'); io.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Safety net: if anything is still hidden after load, reveal it.
    window.addEventListener('load', function () {
      setTimeout(function () {
        document.querySelectorAll('.fade-up:not(.vis)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight) el.classList.add('vis');
        });
      }, 400);
    });
  }

  // Background hero video: force muted + attempt autoplay (iOS/Safari quirk).
  // Also honor data-speed attribute (set by liquid from video_speed setting) to slow/speed playback.
  function initHeroVideo(scope) {
    scope = scope || document;
    scope.querySelectorAll('.hero-video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      var rate = parseFloat(v.getAttribute('data-speed'));
      if (!isNaN(rate) && rate > 0 && rate <= 4) {
        var applyRate = function () { try { v.playbackRate = rate; } catch (e) {} };
        applyRate();
        // Some browsers (iOS Safari) reset playbackRate when metadata/play start — reapply.
        v.addEventListener('loadedmetadata', applyRate);
        v.addEventListener('play', applyRate);
      }
      var p = v.play();
      if (p && p.catch) { p.catch(function () { /* autoplay blocked (e.g. iOS low-power) — poster shows */ }); }
    });
  }

  // Count-up animation for spotlight stat numbers (the "mini counter").
  // Robust against: Theme Editor re-renders, back/forward nav, late-loaded DOM,
  // hidden tabs (uses setInterval not rAF), and reduced-motion preferences.
  function initCounters(scope) {
    scope = scope || document;
    var nums = scope.querySelectorAll('.rspot-num[data-count]');
    if (!nums.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function run(el) {
      if (el.dataset.counting === '1') return; // animation in progress — don't restart
      var target = parseInt((el.getAttribute('data-count') || '').replace(/\D/g, ''), 10);
      if (isNaN(target)) return;
      // Skip if already at the target AND already counted once (idempotent on re-init)
      if (el.dataset.counted === '1' && el.textContent.trim() === String(target)) return;
      el.dataset.counted = '1';
      el.dataset.counting = '1';
      if (reduce) { el.textContent = target; el.dataset.counting = '0'; return; }
      // Slightly longer duration so the count is clearly visible (was 1100ms — too fast).
      var dur = 1800, steps = 36, i = 0;
      el.textContent = '0';
      var timer = setInterval(function () {
        i++;
        var p = Math.min(i / steps, 1);
        var eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
        el.textContent = Math.round(eased * target);
        if (p >= 1) { el.textContent = target; el.dataset.counting = '0'; clearInterval(timer); }
      }, dur / steps);
    }
    function inView(el) {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Trigger as soon as ANY pixel of the element enters the viewport (more eager than IO 0.35).
      return r.top < vh && r.bottom > 0;
    }
    function sweep() { nums.forEach(function (el) { if (inView(el)) run(el); }); }

    // Reset counted/counting flags on EVERY init call so re-renders (Theme Editor edits,
    // shopify:section:load) restart the animation cleanly with the new data-count value.
    nums.forEach(function (el) {
      delete el.dataset.counted;
      delete el.dataset.counting;
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
      nums.forEach(function (el) { io.observe(el); });
    }
    // Safety nets at multiple times: catch anything already in view or deferred.
    sweep();
    setTimeout(sweep, 300);
    setTimeout(sweep, 1200);
    window.addEventListener('load', function () { setTimeout(sweep, 200); });
    window.addEventListener('scroll', sweep, { passive: true });
  }

  // Enrollment modal — open on grupa card click, populate with year/age, auto-open if flash msg present.
  function initGroupsModal(scope) {
    scope = scope || document;
    var cards = scope.querySelectorAll('.gcard[data-open]');
    var modals = scope.querySelectorAll('.grp-modal');
    if (!cards.length && !modals.length) return;

    function openModal(modal) {
      if (!modal) return;
      modal.removeAttribute('hidden');
      // double rAF so the transition runs from initial state
      requestAnimationFrame(function () { requestAnimationFrame(function () { modal.classList.add('open'); }); });
      document.documentElement.classList.add('eagles-modal-open');
      var firstInput = modal.querySelector('input:not([readonly]):not([type="hidden"]), textarea');
      if (firstInput) setTimeout(function () { try { firstInput.focus(); } catch (e) {} }, 320);
    }
    function closeModal(modal) {
      if (!modal) return;
      modal.classList.remove('open');
      var anyOpen = document.querySelector('.grp-modal.open');
      if (!anyOpen) document.documentElement.classList.remove('eagles-modal-open');
      setTimeout(function () {
        if (!modal.classList.contains('open')) modal.setAttribute('hidden', '');
      }, 320);
    }

    cards.forEach(function (card) {
      if (card.dataset.modalBound) return;
      card.dataset.modalBound = '1';
      card.addEventListener('click', function () {
        var modalId = card.getAttribute('data-open');
        var modal = document.getElementById(modalId);
        if (!modal) return;
        var year = card.getAttribute('data-year') || '';
        var age = card.getAttribute('data-age') || '';
        var spots = card.getAttribute('data-spots') || '';
        var base = card.getAttribute('data-base') || '';
        modal.querySelectorAll('[data-modal-year]').forEach(function (el) {
          el.textContent = year ? ('grupa ' + year) : 'grupa Eagles';
        });
        modal.querySelectorAll('[data-modal-an]').forEach(function (el) { el.value = year; });
        modal.querySelectorAll('[data-modal-age]').forEach(function (el) { el.value = age; });
        modal.querySelectorAll('[data-modal-grupa]').forEach(function (el) {
          el.value = year + (age ? ' (' + age + ')' : '') + (base ? ' · ' + base : '') + (spots ? ' · ' + spots + ' locuri' : '');
        });
        openModal(modal);
      });
    });

    // Close handlers (delegated) — bound only once per modal
    modals.forEach(function (modal) {
      if (modal.dataset.closeBound) return;
      modal.dataset.closeBound = '1';
      modal.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest && t.closest('[data-close]')) closeModal(modal);
      });
      // Auto-open if the server rendered a flash message (post-submit reload)
      if (modal.querySelector('[data-flash]')) {
        setTimeout(function () { openModal(modal); }, 120);
      }
    });

    if (!document._eaglesModalEscBound) {
      document._eaglesModalEscBound = '1';
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          var openOnes = document.querySelectorAll('.grp-modal.open');
          openOnes.forEach(function (m) { closeModal(m); });
        }
      });
    }
  }

  // EAGLES CART DRAWER — slide-in panel, syncs with Shopify cart API
  function initCartDrawer() {
    var toggle = document.getElementById('eaglesCartToggle');
    var drawer = document.getElementById('eaglesCartDrawer');
    var overlay = document.getElementById('eaglesCartOverlay');
    var closeBtn = document.getElementById('eaglesCartClose');
    if (!toggle || !drawer || !overlay) return;

    function fmtMoney(cents) {
      // Simple RON formatter — matches Shopify {{ money }} basic output
      return (cents / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
    }

    function openDrawer() {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('eagles-cart-open');
      refreshCart();
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('eagles-cart-open');
    }

    if (!toggle.dataset.bound) {
      toggle.dataset.bound = '1';
      toggle.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    }
    if (overlay && !overlay.dataset.bound) { overlay.dataset.bound = '1'; overlay.addEventListener('click', closeDrawer); }
    if (closeBtn && !closeBtn.dataset.bound) { closeBtn.dataset.bound = '1'; closeBtn.addEventListener('click', closeDrawer); }
    if (!document._eaglesCartEscBound) {
      document._eaglesCartEscBound = '1';
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer(); });
    }

    // Fetch /cart.js + rebuild body + update header badge
    function refreshCart() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function (e) { console.error('Eagles cart fetch failed', e); });
    }

    function renderCart(cart) {
      var body = document.getElementById('eaglesCdBody');
      var foot = document.getElementById('eaglesCdFoot');
      var badge = document.getElementById('eaglesCartCount');
      var titleCount = document.getElementById('eaglesCdCount');
      var totalEl = document.getElementById('eaglesCdTotal');
      if (!body) return;

      var count = cart.item_count || 0;
      if (badge) {
        badge.textContent = count;
        if (count > 0) { badge.removeAttribute('hidden'); badge.style.animation = 'none'; void badge.offsetWidth; badge.style.animation = ''; }
        else badge.setAttribute('hidden', '');
      }
      if (titleCount) titleCount.textContent = count + ' ' + (count === 1 ? 'produs' : 'produse');
      if (totalEl) totalEl.textContent = fmtMoney(cart.total_price);

      if (count === 0) {
        body.innerHTML = '<div class="cd-empty">' +
          '<div class="cd-empty-ico"><svg viewBox="0 0 80 80" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 12 12 24v44a4 4 0 0 0 4 4h48a4 4 0 0 0 4-4V24L58 12Z"/><path d="M12 24h56"/><path d="M52 36a12 12 0 0 1-24 0"/></svg></div>' +
          '<p class="cd-empty-title">Coșul tău e gol</p>' +
          '<p class="cd-empty-text">Echipamentul oficial Eagles te așteaptă — tricouri, treninguri, geci.</p>' +
          '<a href="/collections/all" class="btn btn-gold cd-empty-cta">Vezi magazinul<span class="arrow">→</span></a>' +
          '</div>';
        if (foot) foot.setAttribute('hidden', '');
        return;
      }

      if (foot) foot.removeAttribute('hidden');
      var html = '<ul class="cd-items">';
      cart.items.forEach(function (item) {
        var img = item.image ? '<img src="' + item.image + '&width=180" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="90" height="90">' : '';
        var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="cd-item-variant">' + escapeHtml(item.variant_title) + '</span>' : '';
        html += '<li class="cd-item" data-key="' + item.key + '">' +
          '<a class="cd-item-img" href="' + item.url + '">' + img + '</a>' +
          '<div class="cd-item-info">' +
            '<a class="cd-item-title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
            variantTitle +
            '<div class="cd-item-bot">' +
              '<div class="cd-qty" data-line-key="' + item.key + '">' +
                '<button class="cd-qty-btn" data-qty-minus type="button" aria-label="Scade">−</button>' +
                '<input class="cd-qty-val" type="number" min="0" value="' + item.quantity + '" data-qty-input aria-label="Cantitate">' +
                '<button class="cd-qty-btn" data-qty-plus type="button" aria-label="Crește">+</button>' +
              '</div>' +
              '<span class="cd-item-price">' + fmtMoney(item.final_line_price) + '</span>' +
            '</div>' +
          '</div>' +
          '<button class="cd-item-x" data-remove="' + item.key + '" type="button" aria-label="Elimină">' +
            '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 3l10 10M13 3L3 13"/></svg>' +
          '</button>' +
        '</li>';
      });
      html += '</ul>';
      body.innerHTML = html;
      bindItemEvents();
    }

    function escapeHtml(s) {
      return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function bindItemEvents() {
      // Remove buttons
      document.querySelectorAll('#eaglesCdBody [data-remove]').forEach(function (btn) {
        btn.addEventListener('click', function () { changeLine(btn.getAttribute('data-remove'), 0); });
      });
      // Qty +/-
      document.querySelectorAll('#eaglesCdBody .cd-qty').forEach(function (qty) {
        var key = qty.getAttribute('data-line-key');
        var input = qty.querySelector('[data-qty-input]');
        var minus = qty.querySelector('[data-qty-minus]');
        var plus = qty.querySelector('[data-qty-plus]');
        if (minus) minus.addEventListener('click', function () { var v = Math.max(0, parseInt(input.value, 10) - 1); changeLine(key, v); });
        if (plus) plus.addEventListener('click', function () { changeLine(key, parseInt(input.value, 10) + 1); });
        if (input) input.addEventListener('change', function () { changeLine(key, Math.max(0, parseInt(input.value, 10) || 0)); });
      });
    }

    function changeLine(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function (e) { console.error('Eagles cart change failed', e); });
    }

    // Intercept ALL add-to-cart forms on the site → open drawer after add
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.action || !/\/cart\/add/.test(form.action)) return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { openDrawer(); })
        .catch(function (err) { console.error('Eagles cart add failed', err); form.submit(); });
    }, true); // capture phase to catch before Shopify's handlers

    // Initial badge refresh
    refreshCart();
  }

  function init() { initHeader(); reveal(); initHeroVideo(); initCounters(); initGroupsModal(); initCartDrawer(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.addEventListener('resize', setPromoHeight, { passive: true });

  document.addEventListener('shopify:section:load', function (e) {
    initHeader();
    reveal(e.target || document);
    initHeroVideo(e.target || document);
    initCounters(e.target || document);
    initGroupsModal(e.target || document);
    initCartDrawer();
  });

  /* ===== EAGLES FLYBALL — occasional football shot across the screen =====
     - First appearance: 45s after page load (not aggressive)
     - Subsequent: random interval 90-180s
     - Direction, vertical position, speed randomized for variety
     - Skips on prefers-reduced-motion
     - Stops if tab is hidden (no spawning while user not looking) */
  function initFlyball() {
    var minDelay = 60000, maxDelay = 140000, firstDelay = 8000;
    var BALL_GIF = 'https://cdn.shopify.com/s/files/1/0991/5652/5431/files/eagles-flyball.gif?v=1780403002';

    // Preload the GIF so first spawn is instant
    var pre = new Image(); pre.src = BALL_GIF;

    function spawnBall() {
      if (document.hidden) { scheduleNext(); return; }
      var b = document.createElement('img');
      b.className = 'eagles-flyball';
      b.setAttribute('aria-hidden', 'true');
      b.alt = '';
      b.src = BALL_GIF;
      // Vertical: middle band (30-65vh) — high enough to spot, not in edges
      var topPct = 30 + Math.floor(Math.random() * 35);
      b.style.top = topPct + 'vh';
      // Random direction: left-to-right or right-to-left
      var dir = Math.random() > 0.5 ? 'ltr' : 'rtl';
      b.classList.add('eagles-flyball--' + dir);
      // Slower so user can actually see the ball: 2.0-2.8s
      var dur = (2.0 + Math.random() * 0.8).toFixed(2);
      b.style.animationDuration = dur + 's';
      document.body.appendChild(b);
      console.log('[Eagles] flyball spawned:', dir, topPct + 'vh', dur + 's');
      // Auto-remove after animation ends (with buffer)
      setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 3500);
      scheduleNext();
    }

    function scheduleNext() {
      var wait = minDelay + Math.floor(Math.random() * (maxDelay - minDelay));
      setTimeout(spawnBall, wait);
    }

    // Expose manual trigger so user can test in console: window.eaglesFlyball()
    window.eaglesFlyball = spawnBall;

    setTimeout(spawnBall, firstDelay);
    console.log('[Eagles] flyball initialized, first ball in', firstDelay / 1000, 's. Manual trigger: window.eaglesFlyball()');
  }
  initFlyball();

  /* ===== EAGLES AUDIO PLAYER — custom round play button + progress bar ===== */
  function fmt(sec){
    if(!isFinite(sec) || sec < 0) return '0:00';
    var m = Math.floor(sec / 60), s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  }
  function initEaglesAudio(root){
    var nodes = (root || document).querySelectorAll('[data-eagles-audio]');
    nodes.forEach(function(wrap){
      if(wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var audio = wrap.querySelector('[data-eagles-audio-el]');
      var btn = wrap.querySelector('[data-eagles-audio-toggle]');
      var progress = wrap.querySelector('[data-eagles-audio-progress]');
      var fill = wrap.querySelector('[data-eagles-audio-fill]');
      var curEl = wrap.querySelector('[data-eagles-audio-current]');
      var totEl = wrap.querySelector('[data-eagles-audio-total]');
      if(!audio || !btn) return;

      btn.addEventListener('click', function(){
        // Pause any other Eagles audio players on the page
        document.querySelectorAll('[data-eagles-audio-el]').forEach(function(a){
          if(a !== audio && !a.paused){ a.pause(); }
        });
        if(audio.paused){ audio.play(); } else { audio.pause(); }
      });

      audio.addEventListener('play', function(){ wrap.classList.add('is-playing'); btn.setAttribute('aria-label','Pauză imn'); });
      audio.addEventListener('pause', function(){ wrap.classList.remove('is-playing'); btn.setAttribute('aria-label','Redă imnul'); });
      audio.addEventListener('ended', function(){ wrap.classList.remove('is-playing'); if(fill) fill.style.width = '0%'; if(curEl) curEl.textContent = '0:00'; });
      audio.addEventListener('loadedmetadata', function(){ if(totEl) totEl.textContent = fmt(audio.duration); });
      audio.addEventListener('timeupdate', function(){
        if(!audio.duration) return;
        var pct = (audio.currentTime / audio.duration) * 100;
        if(fill) fill.style.width = pct + '%';
        if(curEl) curEl.textContent = fmt(audio.currentTime);
      });

      // Click-to-seek on progress bar
      progress && progress.addEventListener('click', function(e){
        if(!audio.duration) return;
        var rect = progress.getBoundingClientRect();
        var pct = (e.clientX - rect.left) / rect.width;
        audio.currentTime = Math.max(0, Math.min(audio.duration, pct * audio.duration));
      });
    });
  }
  initEaglesAudio();
  document.addEventListener('shopify:section:load', function(e){ initEaglesAudio(e.target || document); });
})();
